export default "__VITE_ASSET__DsA$147D__"